import { TICKS_PER_BEAT, TICKS_PER_STEP } from '../../av/time';

/** Marker snapping on the Sync timeline: beats, sixteenth steps, or free (single ticks). */
export type Snap = 'beat' | 'step' | 'tick';
const SNAP_TICKS: Record<Snap, number> = { beat: TICKS_PER_BEAT, step: TICKS_PER_STEP, tick: 1 };
export const snapTicks = (ticks: number, snap: Snap): number => Math.max(0, Math.round(ticks / SNAP_TICKS[snap]) * SNAP_TICKS[snap]);
